export const AVAILABLE_TIMEZONES = [
  {name: 'Atlantic Standard Time AST GMT -4', value: 'Canada/Atlantic'},
  {name: 'Eastern Standard Time EST GMT -5', value: 'US/Eastern'},
  {name: 'Central Standard Time CST GMT -6', value: 'US/Central'},
  {name: 'Mountain Standard Time MST GMT -7', value: 'US/Mountain'},
  {name: 'Pacific Standard Time PST GMT -8', value: 'US/Pacific'},
  {name: 'Alaskan Standard Time AST GMT -9', value: 'US/Alaska'},
  {name: 'Hawaiian Standard Time HST GMT -10', value: 'US/Hawaii'}
];



// WEBPACK FOOTER //
// ./src/components/pages/churches/constants.js